export default "__VITE_ASSET__114949ba__"